import { render, staticRenderFns } from "./VisitsTable.vue?vue&type=template&id=1607b181&scoped=true"
import script from "./VisitsTable.vue?vue&type=script&lang=ts"
export * from "./VisitsTable.vue?vue&type=script&lang=ts"
import style0 from "./VisitsTable.vue?vue&type=style&index=0&id=1607b181&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1607b181",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1607b181')) {
      api.createRecord('1607b181', component.options)
    } else {
      api.reload('1607b181', component.options)
    }
    module.hot.accept("./VisitsTable.vue?vue&type=template&id=1607b181&scoped=true", function () {
      api.rerender('1607b181', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/VisitsTable.vue"
export default component.exports